import { useEffect, useState } from "react";

import { useConnectionState } from "../hooks/useConnectionState";
import { cn } from "../lib/utils";

/**
 * How long the connection must stay down before we say anything. Most
 * reconnects finish well inside this window — announcing them would turn a
 * recovery the user never noticed into a visible failure.
 */
const ANNOUNCE_AFTER_MS = 1_500;

export function ConnectionStatusBanner() {
  const state = useConnectionState();
  const isDown = state === "closed" || state === "reconnecting";
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isDown) {
      setVisible(false);
      return;
    }
    const timer = setTimeout(() => {
      setVisible(true);
    }, ANNOUNCE_AFTER_MS);
    return () => {
      clearTimeout(timer);
    };
  }, [isDown]);

  if (!visible) {
    return null;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        "pointer-events-none fixed inset-x-0 z-50 flex justify-center",
        // Sits below the notch on installed mobile clients and below the
        // titlebar everywhere else.
        "top-[max(0.5rem,env(safe-area-inset-top))]",
      )}
    >
      <div className="pointer-events-auto flex items-center gap-2 rounded-full border border-border bg-popover px-3 py-1.5 text-xs text-popover-foreground shadow-lg">
        <span aria-hidden="true" className="size-1.5 animate-pulse rounded-full bg-amber-500" />
        Reconnecting…
      </div>
    </div>
  );
}
